"use client";

import React, { useEffect, useState } from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statsData = [{
  endValue: 1200,
  suffix: "+",
  label: "Hours of Prayer"
}, {
  endValue: 850,
  suffix: "+",
  label: "Seniors Visited"
}, {
  endValue: 150,
  suffix: "+",
  label: "Active Volunteers"
}, {
  endValue: 100,
  suffix: "%",
  label: "Community Funded"
}];
function AnimatedCounter({
  end,
  suffix,
  label,
  index
}: {
  end: number;
  suffix: string;
  label: string;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.5
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (isVisible) {
      let start = 0;
      const duration = 2000;
      const frameRate = 1000 / 60;
      const totalFrames = Math.round(duration / frameRate);
      const increment = end / totalFrames;
      let currentFrame = 0;
      const timer = setInterval(() => {
        currentFrame++;
        start += increment;
        if (currentFrame >= totalFrames) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, frameRate);
      return () => clearInterval(timer);
    }
  }, [isVisible, end]);
  return <div ref={ref} data-index={index} className="flex flex-col items-center justify-center space-y-3 p-6 transition-all duration-700 ease-out" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(20px)",
    transitionDelay: `${index * 150}ms`
  }}>
      <div className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-primary tracking-tight">
        {count}
        {suffix}
      </div>
      <div className="font-sans text-sm md:text-base text-muted-foreground uppercase tracking-widest font-medium">
        {label}
      </div>
    </div>;
}
export default function ByTheNumbers() {
  return;
}